document.addEventListener('DOMContentLoaded', function() {
  const outfitSelect = document.getElementById('outfit-select');
  const topSelect = document.getElementById('top-select');
  const bottomSelect = document.getElementById('bottom-select');
  const capsule5Select = document.getElementById('capsule-5-select');
  const capsule10Select = document.getElementById('capsule-10-select');
  const previewArea = document.getElementById('capsule-preview');

  // Function to update the preview based on the selection
  function updatePreview() {
    const outfit = outfitSelect.value;
    const top = topSelect.value;
    const bottom = bottomSelect.value;

    previewArea.innerHTML = `<h3>Preview: ${outfit}</h3><p>Top: ${top}</p><p>Bottom: ${bottom}</p>`;
  }

  // Event listeners for the select elements
  outfitSelect.addEventListener('change', updatePreview);
  topSelect.addEventListener('change', updatePreview);
  bottomSelect.addEventListener('change', updatePreview);

  capsule5Select.addEventListener('change', updatePreview);
  capsule10Select.addEventListener('change', updatePreview);
});
